import app from '@/app';

var component = {
	templateUrl: '/app/admin/organization/road-delete-confirm-dialog.html',
	controller: Controller,
	bindings: {
		resolve: '<',
		close: '&',
		dismiss: '&'
	}
};

/* @ngInject */
function Controller() {
	var $ctrl = this;

	this.$onInit = function() {
		$ctrl.roads = $ctrl.resolve.bindings.roads;
		$ctrl.dependencies = $ctrl.resolve.bindings.dependencies;
	};

	$ctrl.confirm = function() {
		$ctrl.close({ $value: true });
	};

	$ctrl.cancel = function() {
		$ctrl.dismiss({ $value: 'cancel' });
	};
}

app.component('roadDeleteConfirmDialog', component);
